import React, {useState} from 'react'
import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'
import { Modal, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'

const reload = () => window.location.reload()

const PUBLISH = gql`
  mutation unpublishFile($input: UnpublishFileInput!) {
    unpublishFile(input: $input) {
      itemFile {
        id
      }
    }
  }
`

export default function PublishFileModal(props) {
  const [ isComplete, setIsComplete ] = useState(false)
  const [ publish ] = useMutation(
    PUBLISH,
    {
      variables: {
        input: {
          cuid: props.row.cuid + '',
          key: props.itemId + '/'+ props.row.name
        }
      }
    }
  )

  const handleClose = () => {
    props.onHide()
    reload()
  }

  return (
    <Modal {...props} size="lg" onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Unpublish File</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form
          onSubmit= {e => {
            e.preventDefault()
            publish()
            setIsComplete(true)
          }}
        >
          <h3>You are about to unpublish file: {props.row.name}</h3>
          <br/>
          <p>Your file will be deleted from the public bucket, and file will be moved to the source bucket.</p>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>Close</Button>
            {isComplete?'':<Button variant="primary" type="submit">Unpublish File</Button>}

          </Modal.Footer>
        </form>
      </Modal.Body>
    </Modal>
  )
}

PublishFileModal.propTypes = {
  row: PropTypes.shape({
    cuid: PropTypes.string,
    bucket: PropTypes.string,
    key: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    scrapeMetadata: PropTypes.any,
    status: PropTypes.shape({
      scanPassed: PropTypes.bool
    })
  }),
  itemId: PropTypes.string,
  onHide: PropTypes.func,
}